const removeTrailingSlash = (value) =>
  String(value ?? "").replace(/\/+$/, "");

const backendRoot = removeTrailingSlash(
  process.env.REACT_APP_USER_API_URL
);

export const TONELAG_API_BASE_URL = backendRoot
  ? `${backendRoot}/tonelag`
  : "/tonelag";

export const getStoredAuthToken = (explicitToken = null) => {
  if (explicitToken) return explicitToken;

  try {
    return localStorage.getItem("token");
  } catch {
    return null;
  }
};

export const buildTonelagHeaders = ({
  authToken = null,
  importToken = null,
  json = false,
  extraHeaders = null,
} = {}) => {
  const token = getStoredAuthToken(authToken);

  return {
    Accept: "application/json",
    ...(json ? { "Content-Type": "application/json" } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(importToken
      ? { "X-Tonelag-Import-Token": importToken }
      : {}),
    ...(extraHeaders ?? {}),
  };
};

export const normalizeTonelagApiBase = (value = null) =>
  removeTrailingSlash(value || TONELAG_API_BASE_URL);
